import * as React from 'react';
import { NavLink, withRouter, RouteComponentProps } from 'react-router-dom';
import Dropdown from '../common/Dropdown';
import { MenuOption } from '../common/MenuOption';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import { default as DispatchProps, mapDispatchToProps } from '../../application/core/DispatchProps';
import { push } from 'react-router-redux';

interface StateProps {
    userName: string;
}

class UserToolbar extends React.PureComponent<StateProps & DispatchProps & RouteComponentProps> {
    private menuElements: MenuOption[] = [
        { text: 'My orders', route: '/orders-history' },
        { text: 'My estimations', route: '/estimations-history' },
        { text: 'My account', route: '/account' },
        { text: 'Logout', route: '/logout' }
    ];

    public render(): JSX.Element {
        return (
            <>
                <NavLink activeClassName="active-link" to="/estimations">
                    Estimation
                </NavLink>
                <NavLink activeClassName="active-link" to="/order">
                    Place order
                </NavLink>
                <Dropdown
                    placeholder={this.props.userName}
                    onChange={this.onSelect}
                    options={this.menuElements.map((menuOption: MenuOption) => menuOption.text)}
                    class="navbar-select"
                    color="white"
                />
            </>
        );
    }
    private onSelect = (value: HTMLSelectElement['value']): void => {
        const selectedOption: MenuOption | undefined = this.menuElements.find((menuOption: MenuOption) => menuOption.text === value);
        if (selectedOption) {
            this.props.dispatch(push(selectedOption.route));
        }
    };
}

const mapStateToProps = (state: State): StateProps => ({
    userName: state.user.name
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(UserToolbar));



// WEBPACK FOOTER //
// ./src/view/admin/UserToolbar.tsx